module.exports = __webpack_public_path__ + "img/mov.1dabc29f.svg";